import { tv, type VariantProps } from "tailwind-variants"
import { classNames } from "../../utils"
import { backgroundVariants } from "./background"
import { borderVariants } from "./border"
import { buttonLayoutVariants } from "./buttonLayout"
import { disabledVariants } from "./disabled"

export type InputVariantProps = VariantProps<typeof inputVariants>

export const inputVariants = tv({
  extend: buttonLayoutVariants,
  base: "w-full text-md placeholder:text-text-secondary ",
  variants: {
    variant: {
      default: classNames(
        "bg-bg-primary hover:bg-bg-secondary",
        borderVariants({ border: "border-1" }),
      ),
      transparent: classNames(
        "bg-bg-primary-transparent hover:bg-bg-secondary-transparent-hover",
        borderVariants({ border: "border-1", transparent: true }),
      ),
      frosted: classNames(
        backgroundVariants({
          background: "frosted",
          interactive: true,
        }),
        borderVariants({ border: "frosted" }),
      ),
      ghost: "px-0",
    },
    disabled: {
      true: disabledVariants({ disabled: true }),
    },
    error: {
      true: "border-error-1",
    },
    warning: {
      true: "border-warning",
    },
  },
  defaultVariants: {
    variant: "default",
  },
  // Placed in compound variants for precedence
  compoundVariants: [
    { variant: "ghost", class: "px-0" },
    {
      variant: "ghost",
      error: true,
      class: "text-error-1 [&_input]:placeholder:text-error-1",
    },
    {
      warning: true,
      error: true,
      class: "border-error-1",
    },
    // Override input padding to max px-3 on any side (keep xs at px-1.5)
    // Default case: px-3 on both sides when no icons
    { size: "sm", class: "px-3" },
    { size: "md", class: "px-3" },
    { size: "lg", class: "px-3" },
    // Left icon cases: reduce left padding, maintain px-3 max on right
    { size: "sm", leftIcon: true, class: "pl-2" },
    { size: "md", leftIcon: true, class: "pl-3" },
    { size: "lg", leftIcon: true, class: "pl-3" },
    // Right icon cases: reduce right padding, maintain px-3 max on left
    { size: "sm", rightIcon: true, class: "pr-2" },
    { size: "md", rightIcon: true, class: "pr-3" },
    { size: "lg", rightIcon: true, class: "pr-3" },
  ],
})
